import {
  TYPE,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function type(state = initialState, action) {
  switch (action.type) {
    case TYPE.handlers.fetch:
    case TYPE.handlers.update:
    case TYPE.handlers.import:
    case TYPE.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case TYPE.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };

    default:
      return state;
  }
}
